var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMeshLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 927.65 424.4",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{isolation:isolate;}.cls-2{fill:none;}.cls-3{fill:#55517b;}.cls-4{fill:#bcbec0;mix-blend-mode:multiply;}.cls-5{fill:url(#linear-gradient);}.cls-6{fill:#dc0451;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 302.33,
    y1: 181.59,
    x2: 207.18,
    y2: 230.03,
    gradientTransform: "matrix(1, 0, 0, -1, 0, 426)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.16,
    stopColor: "#55517b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#dc0451"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M142.75,211.87,172.83,242l30.08-30.08h0l16.39,16.39,16.38-16.39h0L265.79,242l30.08-30.08,16.39,16.4,16.39-16.4-16.39-16.39,23.28-23.28-69.76-69.76-30.08,30,23.41,23.41a12.42,12.42,0,0,0-1.53,1.27l-15,15L219.3,148.92,196,172.19l-15-15a11.5,11.5,0,0,0-1.52-1.27l23.41-23.41-30.08-30.08L103.08,172.2l23.28,23.28L110,211.87l16.39,16.4Zm76.56-16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M172.84,321.31l30.08-30.08-23.41-23.41a11.59,11.59,0,0,1-14.87-1.27l-38.28-38.28-23.28,23.28Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 202.85,
    y: 235.08,
    width: 32.93,
    height: 32.93,
    transform: "translate(-113.63 228.76) rotate(-45)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M265.78,269.94a11.54,11.54,0,0,1-6.67-2.12L235.7,291.23l30.08,30.08,69.76-69.76-23.28-23.28L274,266.55A11.57,11.57,0,0,1,265.78,269.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M328.65,211.87l-12,4.62-4.43,11.78,23.28,23.28-69.76,69.76-30-30.08,23.41-23.41A11.59,11.59,0,0,0,274,266.55l38.28-38.28L310,221.72l-14.16-9.85-30,30.13L235.1,211.27l-15.79,17L205.81,209l-33,33L141,210.08l-14.59,18.19,38.28,38.28a11.59,11.59,0,0,0,14.87,1.27L203,291.23l-30.08,30.08-69.76-69.76,23.28-23.28L112.87,209,78.49,243.35a11.59,11.59,0,0,0,0,16.39h0l86.15,86.15a11.6,11.6,0,0,0,16.39,0l38.28-38.28,38.27,38.28a11.61,11.61,0,0,0,16.4,0l86.15-86.15a11.59,11.59,0,0,0,0-16.39h0ZM196,251.56l23.28-23.29,23.28,23.29-23.28,23.28Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.08,172.2l69.76-69.76,30.08,30.08L179,156.47a11.5,11.5,0,0,1,1.52,1.27l15,15,23.82-23.82L243.5,173.1l15-15a11.5,11.5,0,0,1,1.52-1.27L235.7,132.52l30.08-30.08,69.76,69.76-23.28,23.28,5.42,10.44,11,6,31.48-31.47a11.59,11.59,0,0,0,0-16.39h0L274,77.85a11.59,11.59,0,0,0-16.39,0h0l-38.27,38.27L181,77.85a11.58,11.58,0,0,0-16.38,0h0L78.49,164a11.59,11.59,0,0,0,0,16.39h0L110,211.87l18.16-14.62Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 127.85,
    y: 218.05,
    width: 23.18,
    height: 13.83,
    transform: "translate(-118.23 164.49) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "229.05 238.01 245.44 221.62 236.48 212.65 235.69 211.88 219.31 228.27 219.62 228.59 229.05 238.01"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "179.51 267.82 189.42 277.74 205.81 261.35 196.03 251.56 179.51 267.82"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.81,
    y: 297.4,
    width: 23.18,
    height: 13.85,
    transform: "translate(-147.12 253.47) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 220.81,
    y: 138.69,
    width: 23.18,
    height: 13.84,
    transform: "translate(-34.89 206.98) rotate(-45)"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 292.25,
    y: 213.38,
    width: 13.84,
    height: 23.18,
    transform: "translate(-71.45 277.43) rotate(-45)"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-4",
    points: "242.59 251.56 232.8 261.35 249.19 277.74 259.11 267.82 242.59 251.56"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M274,157.2a11.59,11.59,0,0,0-14.87-1.27,12.42,12.42,0,0,0-1.53,1.27l-38.27,38.29L181,157.2a11.64,11.64,0,0,0-16.39,0L110,211.87l16.39,16.4,46.47-46.47h0l46.47,46.48L265.8,181.8h0l46.47,46.47,16.39-16.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M438,150.61h33.36l32.54,80.27,32.21-80.27h33.2v116H541.05V197l-25.93,69.54h-22.8l-26.09-69.7v69.7H438Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M625.05,267.88c-27.09,0-46.58-18.17-46.58-47.41s19.16-47.4,46.58-47.4c27,0,46,17.84,46,45.93a71.24,71.24,0,0,1-.49,8.26h-64c1,12.05,8.42,17.67,17.51,17.67,7.92,0,12.39-4,14.7-8.92h30.06C664.36,254,648,267.88,625.05,267.88Zm-18.34-56.32h35.35c0-10.08-7.93-15.86-17.34-15.86-9.25,0-16.35,5.62-18,15.86Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M715.09,267.88c-24.61,0-41.13-14-42.45-31.88h27.91c.66,6.44,6.45,11.07,14.21,11.07,7.26,0,11.06-3.3,11.06-7.43,0-14.87-50.21-4.13-50.21-38,0-15.7,13.38-28.58,37.5-28.58,23.78,0,37,13.22,38.81,31.38h-26.1c-.82-6.27-5.61-10.4-13.54-10.4-6.61,0-10.24,2.64-10.24,7.1,0,14.7,49.88,4.3,50.38,38.65C752.42,255.82,738.21,267.88,715.09,267.88Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M761.52,150.61h28.25v36.17c5.61-7.92,15.69-13.37,28.41-13.37,21,0,35,14.53,35,39.3v53.85H825.11V216.51c0-12.55-6.93-19.49-17.67-19.49s-17.67,6.94-17.67,19.49v50.05H761.52Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeshLogo);
export default __webpack_public_path__ + "static/media/meshLogo.744f38718f733cb250a780f5365a8c24.svg";
export { ForwardRef as ReactComponent };